import React, { Component } from 'react';

class BizPartners extends Component {
    state = {
        partners: [
            "Moriya Tourism Development- Jabel Sifa",
            "Aramex Oman",
            "UTTS Group",
            "Ideal Partners",
            "Muscat Bay- Individual units",
            "Qurum 29- Residential units",
            "Al Rajhi Group"
        ]
    }

    render() {
      return (
        <React.Fragment>
            <p id="title">CAFM System</p>
            <ol>
                {
                    this.state.partners.map(p => {
                        return (
                            <li className="liStyle">
                                {p}  
                            </li>
                        )
                    })
                }    
            </ol>   
        </React.Fragment>
      );
   }
}

export default BizPartners;